<template>
  <div ref="comp">
    <svg :width="width" :height="height" v-if="width > 0">
       <circle :cx="centerX" :cy="centerY" :r="radius"
               style="fill:#ccc;"/>
      <text v-for="i in modulus" :key="'label-' + i"
            text-anchor="middle"
            dominant-baseline="middle" :x="labelPosX(i - 1)" :y="labelPosY(i - 1)"
            :style="{'font': 'normal ' + fontSize + 'px sans-serif',
                     'fill': num == (i - 1) ? '#d00' : '#777'}">
         {{ i - 1 }}
       </text>
       <path :d="'M ' + centerX + ' ' + centerY + ' L ' + arrowPosX(num) + ' ' + arrowPosY(num)"
             style="stroke:#000; stroke-width:5px;" />
       <circle :cx="arrowPosX(num)" :cy="arrowPosY(num)" :r="fontSize / 2"
               style="fill:#000;" />
       <circle :cx="centerX" :cy="centerY" :r="fontSize * 2.5"
               style="fill:#fff;" /> 
      <text text-anchor="middle"
            dominant-baseline="middle"
            :x="centerX" :y="(height - fontSize) / 2"
            :style="'font: normal ' + fontSize + 'px sans-serif; fill:#d00; font-weight:bold'">
         <tspan :x="centerX">mod</tspan>
         <tspan :x="centerX" dy="1.2em">{{ modulus }}</tspan>
       </text>
    </svg>
  </div>
</template>

<script>
export default {
  data () {
    return {
      width: 320,
      height: 320,
      fontSize: 16,
    }
  },
  props: ['num', 'modulus'],
  computed: {
    radius() {
      return this.width / 2 - 2 * this.fontSize
    },
    halfWidth() {
      return this.width / 2
    },
    halfHeight() {
      return this.height / 2
    },
    centerX() {
      return this.halfWidth
    },
    centerY() {
      return this.halfHeight
    }
  },
  methods: {
    numberPos(i) {
      return i
    },
    directionX(i) {
      return Math.sin(i / this.modulus * -2 * Math.PI + Math.PI)
    },
    directionY(i) {
      return Math.cos(i / this.modulus * -2 * Math.PI + Math.PI)
    },
    labelPosX(i) {
      return this.centerX + this.directionX(i) * (this.halfWidth - this.fontSize)
    },
    labelPosY(i) {
      return this.centerY + this.directionY(i) * (this.halfHeight - this.fontSize)
    },
    arrowPosX(i) {
      return this.centerX + this.directionX(i) * (this.halfWidth - 2.5 * this.fontSize)
    },
    arrowPosY(i) {
      return this.centerY + this.directionY(i) * (this.halfHeight - 2.5 * this.fontSize)
    }
  },
}
</script>
